// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__l2Ysr","icon":"Alert_icon__aAtA6","title":"Alert_title__MpdG6","message":"Alert_message__UwHM4","bgIcon":"Alert_bgIcon__IJrw7"};